import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=53f73e2d"
import script from "./InstallButton.vue?vue&type=script&lang=js"
export * from "./InstallButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f73e2d')) {
      api.createRecord('53f73e2d', component.options)
    } else {
      api.reload('53f73e2d', component.options)
    }
    module.hot.accept("./InstallButton.vue?vue&type=template&id=53f73e2d", function () {
      api.rerender('53f73e2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InstallButton.vue"
export default component.exports